module.exports = __webpack_public_path__ + "static/img/logo.f9ccfee.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/monitoringCenter/images/logo.png
// module id = 564J
// module chunks = 42